import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SnackbarState {
  isOpen: boolean;
  snackbarData: {
    message: string;
    severity: string;
    details?: string;
    // Posição vertical do snackbar. Default "bottom" preserva comportamento
    // legado. Use "top" pra mensagens que precisam não tapar legenda/painéis
    // no rodapé do mapa (ex: notificação de auto-ocorrências).
    position?: "top" | "bottom";
  };
}

const initialState: SnackbarState = {
  isOpen: false,
  snackbarData: {
    message: "",
    severity: "",
    details: undefined,
    position: "bottom",
  },
};

export const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    setSnackBarOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setSnackbarData: (
      state,
      action: PayloadAction<{
        message?: string;
        severity?: string;
        details?: string;
        position?: "top" | "bottom";
      }>
    ) => {
      state.snackbarData = {
        ...state.snackbarData,
        ...action.payload,
        // Cada snackbar começa do zero — sem position herdada do anterior
        position: action.payload.position ?? "bottom",
      };
    },
  },
});

export const { setSnackBarOpen, setSnackbarData } = snackbarSlice.actions;

export default snackbarSlice.reducer;
